import { BillingItemV26 } from 'src/app/models-v26/billingitem-v26';
import { ContractTreeNodeV26 } from 'src/app/models-v26/contract-v26';
import { ActionResponse } from 'src/app/models/action-response';

export interface State {
  servicesStep: BillingItemV26[];
  contractsStep: ContractTreeNodeV26[];
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  servicesStep: null,
  contractsStep: null,
  response: null,
  errorMessage: null,
};
